import './menu';
import mailto from './mailto';
import './enroll-form';
import './event-card';
import './events-filters';

// Called rather than imported for its side effects: `defineModule()` only returns
// `{ setup, cleanup }`, and the loop that would call it lives in `vendor/swup.ts`,
// which this project does not load yet. Sibling components run at module scope, so
// a bare import is enough for them. When swup is adopted this call goes away.
mailto.setup();
